import moment from 'moment';
export const getRKIRegistrations = (userDetails) => {
    return userDetails?.rkiRegistrations
        ? userDetails.rkiRegistrations
            .filter((registration) => {
            const slettetDato = registration.SlettetDato &&
                moment(registration.SlettetDato, 'DDMMYYYY');
            return moment().isBefore(slettetDato);
        })
            .filter((registration) => !userDetails.rkiDeletions ||
            !userDetails.rkiDeletions.some((deletion) => deletion.debtor.debtorNumber ===
                registration.Debitor.attributes.debitorNr))
        : null;
};
//# sourceMappingURL=helpers.js.map